import registerIframePluginDirective from './IframePluginDirective';
import registerTextCompilerDirective from './ibTextCompilerDirective';
import QuestionControlsDirective from './QuestionControlsDirective';
import registerRichTextEditorTooltipDirective from './richtexteditor/RichTextEditorTooltipDirective';
import { registerCountdownDirective } from './CountdownDirective';
import RichTextEditorDirective from './richtexteditor/RichTextEditorDirective';
import IframePluginController from './IframePluginController';
//import RichTextEditorDirective from './geogebra/GeogebraDirective';
import registerExpandableTextareaDirective from './ExpandableTextareaDirective';
import { registerAsfColorboxDirective } from './ColorboxDirective';
import RichTextEditorNewDirective from './richtexteditorNew/RichTextEditorNewDirective';

export default function registerComponents(angular) {
    const app = angular.module('assessmentFrontendControllers');
    const directives = angular.module('assessmentFrontendDirectives');

    app.controller('IframePluginController', [
        'TaskDataService', 'LogBridgeService', '$scope', '$element', '$signals', '$bridges', 'ObjectInstanceRegistrationService', '$sce',
        (...deps) => new IframePluginController(...deps)
    ]);

    registerTextCompilerDirective(angular);
    registerCountdownDirective(directives);
    registerRichTextEditorTooltipDirective(directives);
    registerExpandableTextareaDirective(directives);

    directives.directive('questionControlsDirective', [
        '$compile', '$bridges',
        ($compile, $bridges) => new QuestionControlsDirective($compile, $bridges).getDirective()
    ]);

    directives.directive('richTextEditor', [
        '$rootScope', '$injector', '$', '$window', '$bridges', '$translate', '$config', 'BridgeRuntimeService',
        'InactivityTimeoutService', 'IAAPreferencesService', 'TaskCountdownService', '$timeout', 'dialogs',
        (...deps) => {
            return {
                require: '?ngModel',
                restrict: 'E',
                replace: false,
                scope: {
                    'change': '&',
                    'height': '=height',
                    'formbtns': '=formbtns',
                    'selectableStyles': '@',
                    'placeholder': '@',
                    'contentObject': '='
                },
                controller: RichTextEditorDirective,
                controllerAs: 'ctrl',
                //bindToController: true,
                link: function(scope, element, attrs, ngModel) {
                    scope.ctrl.link(scope, element, attrs, ngModel);
                }
            };
        }
    ]);

    registerAsfColorboxDirective(directives);
    registerIframePluginDirective(directives);

    directives.directive('ckEditor5', [
        '$rootScope', '$injector', '$', '$window', '$bridges', '$translate', '$config', 'BridgeRuntimeService',
        'InactivityTimeoutService', 'IAAPreferencesService', 'TaskCountdownService', '$timeout', 'dialogs', '$signals',
        (...deps) => {
            const [
                $rootScope, $injector, $, $window, $bridges, $translate, $config, BridgeRuntimeService,
                InactivityTimeoutService, IAAPreferencesService, TaskCountdownService, $timeout, dialogs, $signals
            ] = deps;

            return {
                restrict: 'EA', 
                replace: true, 
                scope: {
                    'change': '&',
                    "contentObject": "=",
                    "ngReady": "&",
                    "disabled": "@",
                    "restrictedEditingMode": "@",
                    "placeholder": "@",
                    "writingDirection": "=",
                    "height": "@",
                    "wordcount": "@",
                    "textObject": "@",
                    "ngModel": "=",
                    "onChange": "&"
                },
                controller: RichTextEditorNewDirective,
                controllerAs: 'ctrl',
                link: function(scope, element, attrs, ngModel) {
                    scope.ctrl.link(scope, element, attrs, ngModel);
                }
            };
        }
    ]);
}
